import { useEffect, useState, useContext, useRef } from 'react'
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
import axios from 'axios';
import BankContext from '../../Context/bank'
import LangContext from '../../Context/lang';
import { Link} from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import { useInView } from 'framer-motion'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 1400 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 1400, min: 991 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 991, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2
  }
};

const Topannonces = ({ type }) => {

  const { GetTaksitPrice , bankActive} = useContext(BankContext);
  const { Lang, NavMenu, Global } = useContext(LangContext);



  const [Topannonces, setTopannonces] = useState([])

  const DiarDzairTopAnnonces = useRef(null);
  const DiarDzairTopAnnoncesInView = useInView(DiarDzairTopAnnonces, { once: true });
  const [InView, setInView] = useState(false)

  useEffect(() => {

    const fetchData = async () => {
      // setLoading(true);
      try {
        const { data: response } = await axios.get(`https://diardzair.com.dz/ws/searchText?q=&page=1&parent=${type === 'gift' ? 'Dar-Taksit' : 'electromenager'}`);
        // console.log(response[0]);
        setTopannonces(response[0]);
        // console.log(Topannonces)

      } catch (error) {
        // console.error(error.message);
      }
      // setLoading(false);
    }

    if (DiarDzairTopAnnoncesInView) {

      fetchData();
      // setInView(true);
    }

    // fetchData();

  }, [DiarDzairTopAnnoncesInView]);


  return (
    <section ref={DiarDzairTopAnnonces} style={type === 'gift' ? { background: 'white' } : {}} className={type !== 'gift' ? `top-annonces home-page-top-annonces pt-5 pb-5` : `top-annonces home-page-top-annonces mt-2 pt-4 pb-5`}>

      <div className="container">
        <div className="d-flex justify-content-center align-items-cenetr flex-wrap g-3">

        <Link to="/dartaksit/dossier"><div className={`btn-call-nav top-bar-${bankActive} me-2 mb-1`}>
                {NavMenu['Dossier-dartaksit'][Lang]} {"->"}
              </div>
              </Link>
              <Link to="/dartaksit/conditions"><div className={`btn-call-nav top-bar-${bankActive} mb-1`}>
                {Global['conditions'][Lang]} {"->"}
              </div>
              </Link>
        </div>
        <div className="title-section">{type !== "gift" ? (Global['TopAnnonce'][Lang]) : (NavMenu['Cadeaux'][Lang])}</div>
        <div className="row gy-5">
          {/* <Carousel infinite={false} draggable={false} autoPlay={true} autoPlaySpeed={1000} responsive={responsive}> */}

          <Swiper
            // install Swiper modules
            slidesPerView={"auto"}
            modules={[Navigation, Autoplay]}
            // loop={true}
            spaceBetween={20}
            freeMode={true}
          // slidesPerView={6}
          // breakpoints={{
          //   0: {
          //     slidesPerView: 1,
          //   },
          //   340: {
          //     slidesPerView: 2,
          //   },
          //   // when window width is >= 640px
          //   640: {
          //     slidesPerView: 2,
          //   },
          //   // when window width is >= 768px
          //   768: {
          //     slidesPerView: 2,
          //   },
          //   992: {
          //     slidesPerView: 3,
          //     spaceBetween: 8
          //   },
          //   1200: {
          //     slidesPerView: 5,
          //     spaceBetween: 20,

          //   },

          // }}
          navigation
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          // onSwiper={(swiper) => console.log(swiper)}
          // onSlideChange={() => console.log('slide change')}
          >

            {Topannonces.length > 0 && Topannonces.map((item, i) => (
              <SwiperSlide key={`HomePage${item?.hash + i}`} style={{ width: 'auto' }}>

                <div className="col">
                  <a href={"/product/" + item?.hash}>
                    <div className="card-product">
                      <div className="first-section-product">
                        <div className="img-product"><img alt={item?.nom} className="img-fluid" src={`https://diardzair.com.dz/${item?.image}`} /></div>
                        <div className="title-product">{item?.nom.length > 20 ? item?.nom.substring(0, 20) + '....' : item?.nom.substring(0, 20)}</div>
                        <div className="mark-product">{item?.marque}</div>
                      </div>
                      <div className={`${type === 'gift' ? 'price-gift-top' : ''} price-product top-bar-${bankActive}`}>
                        {item.free == false ?
                          <div className={`tag-taksit top-bar-${bankActive}`}>

                            { bankActive == "alsalam" ?
                              <svg xmlns="http://www.w3.org/2000/svg" className='svg-tag-white' width="70" viewBox="0 0 43.966 14.86">
                              <g id="Groupe_98" data-name="Groupe 98" transform="translate(-74.461 -547.046)">
                                <path id="Tracé_236" data-name="Tracé 236" d="M361.931,550.634a.329.329,0,0,0-.2-.029c-.78,0-1.56,0-2.34,0a.421.421,0,0,0-.355.156,7.606,7.606,0,0,0-1.747,3.224.22.22,0,0,1-.248.2c-.969.025-1.935-.034-2.9-.079-.148-.007-.164-.077-.151-.2a7.271,7.271,0,0,1,4.218-6.125,7.124,7.124,0,0,1,4.786-.549c.069.015.137.035.262.067a14.329,14.329,0,0,0-3.3,2.5c.042.08.108.048.159.048.839,0,1.677,0,2.516,0a.414.414,0,0,0,.281-.1,7.314,7.314,0,0,1,1.794-1.123,1.939,1.939,0,0,1,.334-.1.386.386,0,0,1,.5.476,2.58,2.58,0,0,1-.338.845,7.72,7.72,0,0,1-2.034,2.258,10.3,10.3,0,0,1-2.58,1.471c-.047.019-.1.066-.144.035s-.012-.108,0-.162a5.961,5.961,0,0,1,1.425-2.691c.025-.029.048-.061.071-.092C361.93,550.658,361.929,550.65,361.931,550.634Z" transform="translate(-250.384 0)" fill="#038e93" />
                                <path id="Tracé_237" data-name="Tracé 237" d="M97.915,579.661a1.658,1.658,0,0,1-1.612.863c-.683,0-1.366-.022-2.048.005a1.264,1.264,0,0,1-1.386-.783c-.029.023-.05.032-.055.046a1.65,1.65,0,0,1-2.276.7,1.425,1.425,0,0,1-.546-.57c-.033-.054-.065-.139-.124-.015a1.447,1.447,0,0,1-1.632.737,1.269,1.269,0,0,1-1.04-.574c-.012.068-.018.092-.019.115-.011.34-.01.341-.36.341-.982,0-1.964-.016-2.946.006a1.285,1.285,0,0,1-1.282-.77c-.011-.022-.027-.043-.056-.09a1.681,1.681,0,0,1-.453.535,1.779,1.779,0,0,1-1.045.319c-.741,0-1.483-.007-2.224,0a1.175,1.175,0,0,1-1.06-.537.1.1,0,0,0-.086-.055,2.429,2.429,0,0,0-.081.468,3.1,3.1,0,0,1-2.436,2.491l-.019,0c-.37.071-.371.072-.526-.266-.054-.118-.17-.265-.136-.35.043-.107.23-.049.354-.068a2.426,2.426,0,0,0,2.006-1.993,3.487,3.487,0,0,0,.053-.639c0-.969,0-1.937-.014-2.905,0-.18.05-.232.23-.23.558.008.557,0,.558.562s.01,1.118,0,1.677a1.113,1.113,0,0,0,1.12,1.119c.694-.037,1.391-.01,2.087-.008a1.086,1.086,0,0,0,.646-.178.7.7,0,0,0,.328-.546c.044-.61.009-1.22,0-1.831,0-.221,0-.442-.011-.663,0-.1.031-.141.134-.137a4.244,4.244,0,0,0,.468,0c.142-.01.175.05.175.181,0,.65,0,1.3.017,1.95a1.305,1.305,0,0,0,.4.979.84.84,0,0,0,.6.245q1.3-.005,2.595,0c.146,0,.189-.044.188-.189-.006-.878,0-1.755-.008-2.633,0-.168.036-.239.214-.219a2.1,2.1,0,0,0,.39,0c.138-.01.178.044.177.179-.007.52,0,1.04,0,1.56q0,.2.017.409a1.062,1.062,0,0,0,1,1.034,2.38,2.38,0,0,0,.292.014.693.693,0,0,0,.753-.772c-.006-.741-.012-1.482-.025-2.223,0-.146.031-.221.194-.2.184.023.422-.08.542.047s.031.348.033.529c.006.455,0,.91.006,1.365a1.261,1.261,0,0,0,1.585,1.233.7.7,0,0,0,.559-.723c-.006-.851-.015-1.7-.033-2.554,0-.174.046-.233.218-.214s.416-.073.53.033.047.357.05.543c.009.507.008,1.014.008,1.521a1.359,1.359,0,0,0,.162.713.974.974,0,0,0,.9.547c.754-.012,1.509,0,2.263,0a1.4,1.4,0,0,0,.329-.029.811.811,0,0,0,.671-.857c0-.76,0-1.521-.015-2.281,0-.145.031-.2.18-.185.186.019.426-.075.548.035s.034.356.042.541c.025.571-.016,1.144.04,1.714a1.214,1.214,0,0,0,.481.9.761.761,0,0,0,.469.163c.774,0,1.548.006,2.321,0a.722.722,0,0,0,.726-.838c-.033-.661-.021-1.325-.028-1.988,0-.136,0-.273-.006-.409,0-.083.03-.116.114-.114.176,0,.351,0,.527,0,.091,0,.125.03.128.123.03.9.048,1.793.023,2.689a1.257,1.257,0,0,1-1.214,1.242c-.857.055-1.716.03-2.574.02a1.15,1.15,0,0,1-.971-.658C97.988,579.8,97.96,579.745,97.915,579.661Z" transform="translate(0 -26.316)" fill="#005043" />
                                <path id="Tracé_238" data-name="Tracé 238" d="M369.031,621.824a7.034,7.034,0,0,1-1.107,3.547,7.438,7.438,0,0,1-13.678-2.923c-.034-.234-.03-.245.21-.227q1.353.1,2.709.073c.147,0,.148.064.145.179a6.691,6.691,0,0,0,.465,2.9,3.2,3.2,0,0,0,2.7,2.106,5.205,5.205,0,0,0,2.46-.38,9.389,9.389,0,0,0,2.832-1.9,34.851,34.851,0,0,0,3.178-3.3c.021-.025.04-.051.06-.077S369.018,621.808,369.031,621.824Z" transform="translate(-250.605 -66.973)" fill="#005043" />
                                <path id="Tracé_239" data-name="Tracé 239" d="M139.169,623.585c0-.437,0-.437.439-.437.406,0,.406,0,.406.414,0,.463,0,.463-.451.463-.393,0-.393,0-.393-.4Z" transform="translate(-57.963 -68.169)" fill="#005043" />
                                <path id="Tracé_240" data-name="Tracé 240" d="M287.608,623.58c0,.444,0,.444-.453.444-.387,0-.387,0-.387-.393,0-.486,0-.486.492-.486C287.608,623.145,287.608,623.145,287.608,623.58Z" transform="translate(-190.176 -68.166)" fill="#005043" />
                                <path id="Tracé_241" data-name="Tracé 241" d="M300.689,623.586c0,.438,0,.438-.436.438-.409,0-.409,0-.409-.407,0-.471,0-.471.466-.471C300.689,623.146,300.689,623.146,300.689,623.586Z" transform="translate(-201.889 -68.167)" fill="#005043" />
                                <path id="Tracé_242" data-name="Tracé 242" d="M153.112,623.589c0,.437,0,.437-.437.437-.391,0-.391,0-.391-.39,0-.488,0-.488.471-.488.357,0,.357,0,.357.363Z" transform="translate(-69.711 -68.169)" fill="#005043" />
                                <path id="Tracé_243" data-name="Tracé 243" d="M326.057,560.139c0,.436,0,.436-.437.436-.391,0-.391,0-.391-.386,0-.48,0-.48.477-.48C326.057,559.71,326.057,559.71,326.057,560.139Z" transform="translate(-224.628 -11.344)" fill="#005043" />
                                <path id="Tracé_244" data-name="Tracé 244" d="M339.156,560.158c0,.418,0,.418-.415.418s-.414,0-.414-.423c0-.443,0-.443.439-.443C339.156,559.71,339.156,559.71,339.156,560.158Z" transform="translate(-236.36 -11.344)" fill="#005043" />
                                <path id="Tracé_245" data-name="Tracé 245" d="M315.781,632.921a.323.323,0,0,1-.334.329.332.332,0,0,1,.007-.664A.32.32,0,0,1,315.781,632.921Z" transform="translate(-215.571 -76.623)" fill="#038e93" />
                                <path id="Tracé_246" data-name="Tracé 246" d="M240.612,670.563a.323.323,0,0,1,.341.32.317.317,0,0,1-.321.337.322.322,0,0,1-.342-.317A.329.329,0,0,1,240.612,670.563Z" transform="translate(-148.543 -110.641)" fill="#038e93" />
                                <path id="Tracé_247" data-name="Tracé 247" d="M315.449,623.966a.335.335,0,0,1-.333-.331.331.331,0,0,1,.663,0A.328.328,0,0,1,315.449,623.966Z" transform="translate(-215.569 -68.31)" fill="#038e93" />
                                <path id="Tracé_248" data-name="Tracé 248" d="M233.172,670.617a.327.327,0,1,1-.319.347A.328.328,0,0,1,233.172,670.617Z" transform="translate(-141.881 -110.689)" fill="#038e93" />
                                <path id="Tracé_249" data-name="Tracé 249" d="M422.2,580.668a7.4,7.4,0,0,0-1.247-3.323c-.074-.109-.115-.128-.2-.005a8.572,8.572,0,0,1-2.1,1.982,24.519,24.519,0,0,1-4.588,2.434c-.526.223-.415.069-.43.661a3.863,3.863,0,0,0,.063.648,1.884,1.884,0,0,0,1.276,1.541,2.719,2.719,0,0,0,1.408,0,7.248,7.248,0,0,0,2.636-1.22c1.078-.738,2.076-1.582,3.087-2.407A.305.305,0,0,0,422.2,580.668Zm-1.49.953a.38.38,0,0,1-.013-.761.38.38,0,0,1,.013.761Zm.745-.562a.382.382,0,0,1-.38-.384.4.4,0,0,1,.383-.388.383.383,0,0,1,.377.389A.375.375,0,0,1,421.453,581.059Z" transform="translate(-303.81 -27.06)" fill="#038e93" />
                                <path id="Tracé_250" data-name="Tracé 250" d="M209.213,629.293c-.208-.006-.247.072-.246.26.008.93,0,1.859,0,2.789a1.139,1.139,0,0,1-.007.194.253.253,0,0,1-.307.225c-.182-.012-.134-.147-.134-.246,0-.9,0-1.807,0-2.711,0-.518,0-.51-.512-.518-.182,0-.232.057-.231.233.007.93,0,1.859,0,2.789,0,.465,0,.458-.464.457-.168,0-.209-.068-.207-.221.007-.448,0-.9,0-1.346,0-.54,0-.535-.532-.534-.161,0-.214.052-.212.213.008.487.006.975,0,1.463s.076.409-.426.425c-.177.006-.221-.058-.219-.224.008-.559,0-1.118,0-1.677,0-.12-.017-.2-.167-.2-.462.006-.924-.013-1.385.006a.971.971,0,0,0-.945,1.265.754.754,0,0,0,.52.6,1.679,1.679,0,0,0,.535.1c.213,0,.427,0,.679,0a.3.3,0,0,1-.287.127c-.6,0-1.2,0-1.795,0-.149,0-.19-.053-.188-.194.006-.468,0-.936,0-1.4,0-.513,0-.509-.522-.5-.143,0-.192.045-.19.191.007.566,0,1.131.007,1.7,0,.182-.069.22-.23.213s-.279.012-.272-.214c.015-.461,0-.923,0-1.385,0-.507,0-.5-.5-.5-.158,0-.217.043-.214.208.009.526,0,1.053,0,1.58,0,.318,0,.312-.318.313-.142,0-.195-.043-.192-.19.007-.462,0-.923,0-1.385,0-.533,0-.529-.537-.526-.148,0-.206.038-.2.2.01.5.007,1,0,1.5,0,.451.079.39-.406.4-.135,0-.181-.046-.179-.182.007-.468,0-.936,0-1.4,0-.516,0-.51-.511-.513-.168,0-.229.046-.226.221.01.468,0,.936,0,1.4s0,.471-.475.473c-.327,0-.327,0-.2-.306.015-.036.028-.073.041-.11a1.209,1.209,0,0,0-1.2-1.681c-.429.016-.859-.008-1.287.007-.2.007-.262-.064-.248-.257s0-.39,0-.585c0-.538,0-.53-.529-.535-.178,0-.217.06-.216.225.007.864,0,1.729,0,2.594,0,.571,0,.567.573.547.127,0,.172-.048.17-.172-.005-.331,0-.663,0-.995,0-.118.028-.182.162-.18.4.005.807-.008,1.209.005a.632.632,0,0,1,.661.623.785.785,0,0,1-.826.818c-.657,0-1.313,0-1.97,0-.3,0-.277-.046-.289.3-.007.185.03.259.241.259,2.712-.008,5.423,0,8.135-.01.262,0,.519-.026.787-.009.693.045,1.391.013,2.086.015a.809.809,0,0,0,.432-.1c.055-.033.1-.052.154.006a.351.351,0,0,0,.288.09c1.008,0,2.016.006,3.024,0,.52,0,.743-.242.743-.762q0-1.394,0-2.789C209.686,629.3,209.685,629.306,209.213,629.293Zm-4.583,2.764a1.615,1.615,0,0,1-.484-.03.376.376,0,0,1-.029-.715,1.3,1.3,0,0,1,.441-.043c.443,0,.446,0,.443.414S205.063,632.056,204.63,632.057Z" transform="translate(-106.894 -73.666)" fill="#038e93" />
                              </g>
                            </svg> : "تقسيط"

                            }

                          </div>
                          :
                          <div className='tag-dartaksit-category-cadeaux mt-0 mb-0'><img loading="lazy" alt={"cadeaux-diardzair"} width={'60px'} src="/img/cadeaux.png" /> </div>}
                        <div className={Lang === 'ar' ? "price d-flex" : "price"}>{(Lang === 'ar' ? <> <span className='me-1'> {(item?.free == false ? Global['Da'][Lang] : Global['Dajust'][Lang])} </span> {item?.free == false ? GetTaksitPrice(parseInt(item?.prix))['default']?.toLocaleString() : parseInt(item?.prix)?.toLocaleString()}</> : <>{item?.free == false ? GetTaksitPrice(parseInt(item?.prix))['default']?.toLocaleString() : parseInt(item?.prix)?.toLocaleString()}<span> {(item?.free == false ? Global['Da'][Lang] : Global['Dajust'][Lang])}</span></>)}</div>
                      </div>
                    </div>
                  </a>
                </div>
              </SwiperSlide>

            ))
            }

          </Swiper>






          {/* </Carousel> */}
        </div>
      </div>
    </section>

  )
}

export default Topannonces